import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const STORE_CONTEXT_STORAGE_KEY = 'store-context-storage';

const normalizeStore = (store) => {
  if (!store || typeof store !== 'object') return null;
  return {
    ...store,
    storeInfoId: store.storeInfoId ?? store.store_info_id,
    store_info_id: store.store_info_id ?? store.storeInfoId,
    vendorId: store.vendorId ?? store.vendor_id,
    vendor_id: store.vendor_id ?? store.vendorId,
    legacyStoreId: store.legacyStoreId ?? store.legacy_store_id,
    legacy_store_id: store.legacy_store_id ?? store.legacyStoreId,
    storeCode: store.storeCode ?? store.store_code ?? store.code,
    store_code: store.store_code ?? store.storeCode ?? store.code,
    branchCode: store.branchCode ?? store.branch_code,
    branch_code: store.branch_code ?? store.branchCode,
  };
};

export const useStoreContextStore = create(
  persist(
    (set, get) => ({
      allowedStores: [],
      selectedStore: null,
      storeScope: 'single',

      setStoreContext: ({ allowedStores = [], selectedStore = null, storeScope = 'single' } = {}) => {
        const normalizedAllowedStores = (allowedStores || []).map(normalizeStore).filter(Boolean);
        const normalizedSelectedStore = normalizeStore(selectedStore)
          || normalizedAllowedStores.find((store) => store.isSelected)
          || normalizedAllowedStores[0]
          || null;

        set({
          allowedStores: normalizedAllowedStores,
          selectedStore: normalizedSelectedStore,
          storeScope: storeScope || normalizedAllowedStores[0]?.storeScope || 'single',
        });
      },

      setSelectedStore: (store) => {
        const normalizedStore = normalizeStore(store);
        set({ selectedStore: normalizedStore });
      },

      resetStoreContext: () => {
        set({ allowedStores: [], selectedStore: null, storeScope: 'single' });
      },

      getSelectedStoreContext: () => {
        const selectedStore = get().selectedStore;
        return {
          storeInfoId: selectedStore?.storeInfoId || selectedStore?.store_info_id || null,
          vendorId: selectedStore?.vendorId || selectedStore?.vendor_id || null,
          legacyStoreId: selectedStore?.legacyStoreId || selectedStore?.legacy_store_id || null,
        };
      },
    }),
    {
      name: STORE_CONTEXT_STORAGE_KEY,
      partialize: (state) => ({
        allowedStores: state.allowedStores,
        selectedStore: state.selectedStore,
        storeScope: state.storeScope,
      }),
    }
  )
);
